import { useEffect, useState } from 'react'

import CollapseList from 'components/CollapseList'
import Arrow from 'icon/Arrow'
import { helper } from 'utils'

import FieldInput from './FieldInput'

const Dropdown = (props) => {
  const {
    label,
    value,
    name,
    onChange = (val) => {},
    placeholder = null,
    options = [],
    errorText,
    filterable,
  } = props
  const [open, setOpen] = useState(false)
  const [inputValue, setInputValue] = useState('')

  const onInputChange = (val) => {
    setOpen(true)
    const found = options.find((op) => op.label === val)
    if (found) {
      onChange(found.value, name)
    }

    setInputValue(val)
  }

  const onDropDownChange = (val) => {
    const found = options.find((item) => item.value === val)
    if (found) setInputValue(found.label)
    onChange(val, name)
  }

  const optionFilter = (item) => {
    if (!filterable) return true
    return helper.searchString(item.label, inputValue)
  }

  const isReadOnly = !filterable
  const isClearable = filterable

  useEffect(() => {
    const selected = options.findIndex((op) => op.value === value)
    const label = options[selected]?.label
    if (label) {
      setInputValue(label)
    }
  }, [value])

  return (
    <CollapseList
      open={open}
      setOpen={setOpen}
      options={options.filter(optionFilter)}
      value={inputValue}
      onChange={onDropDownChange}
    >
      <FieldInput
        label={label}
        value={inputValue}
        placeholder={placeholder}
        onChange={onInputChange}
        readonly={isReadOnly}
        errorText={errorText}
        clearable={isClearable}
        onClick={() => setOpen(!open)}
        endIcon={<Arrow isUp={open} />}
      />
    </CollapseList>
  )
}

export default Dropdown
